import {
  GET_ALL_SYSTEMS_REQUEST,
  GET_ALL_SYSTEMS_SUCCESS,
  GET_ALL_SYSTEMS_FAIL,
  GET_SYSTEM_BY_NAME_REQUEST,
  GET_SYSTEM_BY_NAME_SUCCESS,
  GET_SYSTEM_BY_NAME_FAIL,
  ADD_SYSTEM_REQUEST,
  ADD_SYSTEM_SUCCESS,
  ADD_SYSTEM_FAIL
} from "../constants/SystemConstants";

import SystemService from "../Services/SystemService";

export const GetAllSystemsAction = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_SYSTEMS_REQUEST });

    const { data } = await SystemService.GetAllSystems();

    dispatch({
      type: GET_ALL_SYSTEMS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_SYSTEMS_FAIL,
      payload: error.message,
    });
  }
};

export const GetSystemByNameAction = (name) => async (dispatch) => {
  try {
    dispatch({ type: GET_SYSTEM_BY_NAME_REQUEST });

    const { data } = await SystemService.GetSystemByName(name);

    dispatch({
      type: GET_SYSTEM_BY_NAME_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_SYSTEM_BY_NAME_FAIL,
      payload: error.message,
    });
  }
};

export const AddSystemAction = (systemData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_SYSTEM_REQUEST });

    const { data } = await SystemService.AddSystem(systemData);

    dispatch({
      type: ADD_SYSTEM_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ADD_SYSTEM_FAIL,
      payload: error.message,
    });
  }
};
